import React from 'react';
import { useTranslation } from 'react-i18next';
import { Footer } from '@askporter/component-library';
import { useConfig } from '@askporter/config-provider';
import LanguagePicker from '../LanguagePicker';

/** Renders a FooterWithLangPicker component */
const FooterWithLangPicker: React.FC = () => {
  const { t } = useTranslation();
  const { tenantDisplay } = useConfig();
  const privacyPolicyUrl = tenantDisplay?.links?.privacyPolicyUrl;
  const termsOfUseUrl = tenantDisplay?.links?.termsOfUseUrl;

  return (
    <Footer
      t={t}
      privacyPolicyUrl={privacyPolicyUrl}
      termsOfUseUrl={termsOfUseUrl}
      languagePicker={<LanguagePicker />}
    />
  );
};

export default FooterWithLangPicker;
